export const getFormData = (data: any) => {
    const demand_supplier_quotes = data?.demand_supplier_quotes?.map(item => {
        return {
            ...item,
            discount_quote_price_no_tax: {
                value: item?.discount_quote_price_no_tax,
                currency: item?.currency?.toLocaleLowerCase(),
            },
            discount_quote_price_with_tax: {
                value: item?.discount_quote_price_with_tax,
                currency: item?.currency?.toLocaleLowerCase(),
            },
            quote_price_no_tax: {
                value: item?.quote_price_no_tax,
                currency: item?.currency?.toLocaleLowerCase(),
            },
            quote_price_with_tax: {
                value: item?.quote_price_with_tax,
                currency: item?.currency?.toLocaleLowerCase(),
            },
            supplier_settle_price: {
                value: item?.supplier_settle_price,
                currency: item?.currency?.toLocaleLowerCase(),
            }
        }
    })

    return {
        ...data,
        demand_supplier_quotes,
    }
}

// 格式化数据模型
export const handleFormData = (data: any, detail: any) => {
    const currency = data?.currency?.toLocaleLowerCase()
    const newQuotes = data?.demand_supplier_quotes?.map(item => {
        return {
            ...item,
            cooperate_account: item.cooperate_account,
            cooperate_account_id: item.cooperate_account_id,
            discount_quote_price_no_tax: item?.discount_quote_price_no_tax?.value,
            summary_total_price_quoted: item?.summary_total_price_quoted?.value,
            quote_price_no_tax: item?.quote_price_no_tax?.value,
            quote_price_with_tax: item?.quote_price_with_tax?.value,
            discount_amount: item?.discount_amount?.value,
            discount_quote_price_with_tax: item?.discount_quote_price_with_tax?.value,
            total_price_quoted: item?.total_price_quoted?.value,
            quote_attachments: item.quote_attachments,
            quote_attachs_blob_keys: item.quote_attachments?.map(item => item?.blob?.key || item?.blob?.blob_key),
            program_desc: item.program_desc,
            requote_price: item?.requote_price?.value,
            currency,
            quote_price: !!detail.is_bind_execution_data? undefined : item?.discount_quote_price_with_tax?.value,
            // 可以用报价，用户筛选
            ableQuote: !!detail.is_bind_execution_data ? item.program_desc : !!item?.discount_quote_price_with_tax?.value,
        }
    })
    return {
        ...data,
        total_quoted: data?.total_quoted?.value,
        demand_supplier_quotes: newQuotes
    }
}

